import { LoadingSpinner, StatusIndicator, Tag, Tooltip } from '@neo4j-ndl/react';
import { InformationCircleIconOutline } from '@neo4j-ndl/react/icons';
import type { Instance, IpFilterDetails } from '@nx/state';
import { isNullish } from '@nx/stdlib';

import { PropertyDisplay } from './property-display';

const getIpFilterStatusIndicator = (status: string): 'success' | 'unknown' | 'info' | 'warning' | 'danger' => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Submitted':
      return 'info';
    case 'Deleted':
      return 'warning';
    case 'Error':
      return 'danger';
    default:
      return 'unknown';
  }
};

export const IpFilterSection = (details: IpFilterDetails | undefined, instance: Instance, loading: boolean) => {
  if (loading || isNullish(details)) {
    return (
      <div className="flex items-center gap-2">
        <PropertyDisplay label="IP Filter" text="Loading..." />
        <LoadingSpinner className="ml-2" />
      </div>
    );
  }
  if (instance.ipFilterId === 'DENY_ALL') {
    return (
      <div className="flex items-center gap-2">
        <PropertyDisplay label="IP Filter" text="Deny All" />
        <Tooltip type="simple" placement="top">
          <Tooltip.Trigger>
            <InformationCircleIconOutline className="text-palette-neutral-text-weaker size-4" />
          </Tooltip.Trigger>
          <Tooltip.Content>Configure IP-filtering for the instance in the settings page</Tooltip.Content>
        </Tooltip>
      </div>
    );
  }
  const { name, status } = details;
  return (
    <div className="flex items-center gap-2">
      <PropertyDisplay label="IP Filter" text={name} />
      <Tag className="whitespace-nowrap">
        <StatusIndicator type={getIpFilterStatusIndicator(status)} />
        {status}
      </Tag>
    </div>
  );
};
